import React, { Component, Fragment } from "react";
import Header from "../Header";
import SideMenu from "../SideMenu";
import Body from "../Body";
// import Footer from "../Footer/Footer";
import { updateUser, deleteUser } from "../../actions/authActions";
import { getAllProperty } from "../../actions/propertyAction";
import { connect } from "react-redux";
import Table from "../common/Table";
//import ViewUser from "./ViewUser";
//import EditUser from "./EditUser";
import Search from "../common/Search";
import Spinner from "../common/Spinner";
import { Link } from "react-router-dom";

export class Property extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowViewUser: false,
      isShowEditUser: false,
      selectUser: {},
      filteredData: [],
      searchInput: ""
    };
  }

  componentDidMount() {
    this.props.getAllProperty();
  }

  handleCancelViewUser = () => {
    this.setState({ isShowViewUser: false, selectUser: {} });
  };

  handleViewClick = id => {
    const { users } = this.props.auth;
    let selectUser = users.find(user => user.id === id);
    this.setState({ isShowViewUser: true, selectUser });
  };

  handleCancelEditUser = () => {
    this.setState({ isShowEditUser: false, selectUser: {} });
  };

  handleEditClick = id => {
    const { users } = this.props.auth;
    let selectUser = users.find(user => user.id === id);
    this.setState({ isShowEditUser: true, selectUser });
  };

  handleActiveClick = id => {
    const { users } = this.props.auth;
    let selectUser = users.find(user => user.id === id);
    let is_active = selectUser.is_active ? 0 : 1;
    this.props.updateUser({ is_active }, id);
  };

  handleDeleteClick = id => {
    this.props.deleteUser(id);
  };

  handleSetData = (data, searchInput) => {
    this.setState({ filteredData: data, searchInput });
  };

  render() {
    const {
      isShowViewUser,
      selectUser,
      isShowEditUser,
      filteredData,
      searchInput
    } = this.state;
    const { properties } = this.props.property;
    let headerStyle = {
      height: 45,
      paddingTop: 15,
      fontWeight: "bold"
    };
    const columns = [
      {
        Header: "S.No",
        id: "row",
        maxWidth: 75,
        headerStyle: headerStyle,
        filterable: false,
        Cell: row => {
          return <div>{row.index + 1}</div>;
        }
      },
      {
        Header: "Id",
        accessor: "id",
        maxWidth: 75,
        headerStyle: headerStyle
      },
      {
        Header: "User Id",
        accessor: "user_id",
        maxWidth: 120,
        headerStyle: headerStyle
      },
      {
        Header: "Title",
        accessor: "title",
        headerStyle: headerStyle
      },
      {
        Header: "Description",
        accessor: "description",
        ///maxWidth: 200,
        headerStyle: headerStyle
      },
      /*       {
        Header: "City",
        accessor: "attachment.class",
        headerStyle: headerStyle
      }, */
      {
        Header: "Action",
        headerStyle: headerStyle,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              textAlign: "center"
            }
          };
        },
        Cell: props => (
          <Fragment>
            <Link to={`property/${props.row.id}`}>
              <button
                type="button"
                className="btn btn-info"
                data-toggle="modal"
                data-target="#modal-default"
                title="View"
                style={{ marginLeft: "10px" }}
                onClick={id => this.handleViewClick(props.row.id)}
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
              </button>
            </Link>

            {/*  <button
              type="button"
              className="btn btn-success"
              data-toggle="tooltip"
              title="Edit"
              style={{ marginLeft: "10px" }}
              onClick={id => this.handleEditClick(props.row.id)}
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </button> */}
            {props.row._original.is_active ? (
              <button
                type="button"
                className="btn btn-warning"
                data-toggle="tooltip"
                title="Status"
                style={{ marginLeft: "10px" }}
                onClick={id => this.handleActiveClick(props.row.id)}
              >
                <i className="fa fa-check" aria-hidden="true"></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-status"
                data-toggle="tooltip"
                title="Status"
                style={{ marginLeft: "10px" }}
                onClick={id => this.handleActiveClick(props.row.id)}
              >
                <i className="fa fa-close" aria-hidden="true"></i>
              </button>
            )}
            <button
              type="button"
              className="btn btn-danger"
              data-toggle="tooltip"
              title="Delete"
              style={{ marginLeft: "10px" }}
              onClick={id => this.handleDeleteClick(props.row.id)}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </button>
          </Fragment>
        ) // Custom cell components!
      }
    ];

    const fields = ["title", "description"];

    return (
      <div className="skin-blue ">
        <div className="wrapper">
          <Header />
          <SideMenu active="user" />
          <Body>
            <section className="content-header">
              <h1>Properties</h1>
              <ol className="breadcrumb">
                <li>
                  <a /* href="#" */>
                    <i className="fa fa-dashboard"></i> Home
                  </a>
                </li>
                <li className="active">Properties</li>
              </ol>
            </section>

            {properties.length > 0 ? (
              <section className="content">
                <div className="row">
                  <div className="col-xs-12">
                    <div
                      className="pull-right"
                      style={{ marginBottom: "10px" }}
                    >
                      <Search
                        data={properties}
                        handleSetData={this.handleSetData}
                        fields={fields}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="box">
                      <div className="box-body">
                        <Table
                          data={
                            filteredData.length > 0
                              ? filteredData
                              : searchInput
                              ? filteredData
                              : properties
                          }
                          columns={columns}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <Spinner />
            )}
            {/*   {isShowViewUser ? (
              <ViewUser
                handleCancelViewUser={this.handleCancelViewUser}
                user={selectUser}
              />
            ) : null}
            {isShowEditUser ? (
              <EditUser
                handleCancelEditUser={this.handleCancelEditUser}
                user={selectUser}
              />
            ) : null} */}
          </Body>
          {/* <Footer /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  property: state.property,
  errors: state.errors
});

export default connect(mapStateToProps, {
  getAllProperty,
  updateUser,
  deleteUser
})(Property);



// WEBPACK FOOTER //
// ./src/components/Property/index.js